import settings from '@/settings'

export default {
  init () {
    if (settings.services.feedback.enabled) {
      const feedbackScript = document.createElement('script')
      feedbackScript.src = 'https://hubbellcdn.com/ohwassets/Hubbell/feedbackjs/feedback.js'
      feedbackScript.async = false
      feedbackScript.defer = true
      feedbackScript.type = 'text/javascript'
      document.head.appendChild(feedbackScript)

      const storeFeedbackScript = document.createElement('script')
      storeFeedbackScript.src = 'https://hubbellcdn.com/ohwassets/Hubbell/feedbackjs/storefeedback.js'
      storeFeedbackScript.async = false
      storeFeedbackScript.defer = true
      storeFeedbackScript.type = 'text/javascript'
      document.head.appendChild(storeFeedbackScript)

      const storeFeedbackStyles = document.createElement('link')
      storeFeedbackStyles.href = 'https://hubbellcdn.com/ohwassets/Hubbell/feedbackjs/feedback.css'
      storeFeedbackStyles.rel = 'stylesheet'
      storeFeedbackStyles.type = 'text/css'
      storeFeedbackStyles.media = 'print'
      storeFeedbackStyles.onload = () => {
        storeFeedbackStyles.media = 'all'
      }
      document.head.appendChild(storeFeedbackStyles)
    }
  }
}
